import React, { useEffect, useRef } from 'react';

declare global {
	interface Window {
		iFrameResize?: any;
	}
}

const IframeComponent = ({ src }: { src: string }) => {
	const iframeRef = useRef<HTMLIFrameElement>(null);

	useEffect(() => {
		// Lade das Script dynamisch
		const script = document.createElement('script');
		script.src = 'https://datenschutzgenerator.hessen-agentur.de/js/V4/iframeResizer.min.js';
		script.onload = () => {
			// Nach dem Laden initialisiere Resizing
			if (window.iFrameResize && iframeRef.current) {
				window.iFrameResize(
					{
						log: false,
						autoResize: true,
						sizeHeight: true,
						maxHeight: Infinity,
					},
					iframeRef.current
				);
			}
		};
		document.body.appendChild(script);
	}, []);

	return (
		<div style={{ width: '100%', overflow: 'hidden' }}>
			<iframe
				ref={iframeRef}
				src={src}
				title='Eingebetteter Inhalt'
				style={{
					width: '100%',
					height: '1px', // Startwert – wächst automatisch
					border: 'none',
				}}
				scrolling='no'
			/>
		</div>
	);
};

export default IframeComponent;
